import app from "@/main";
import {ITask} from "../store/modules/GorevYoneticisiTypes";
import TakipDosya from "./classes/TakipDosya";
import AvukatIcraDosyalari, {AvukatIcraDosyalariTalep, DosyaDurum} from "./AvukatIcraDosyalari";
import {IAvukatDosya} from "./CommonInterfaces";

export class DosyaBul {
    err: any = {};

    constructor() {
        this.err = {message: "Dosya Bulunamadı !"};
    }

    async getMockResponse(): Promise<TakipDosya> {
        console.log("get MockRespinse");
        let adsg = new AvukatIcraDosyalari();
        let data = await adsg.parse(adsg.getMockResponse());
        return TakipDosya.fromJson(data.items[0]);
    }

    run(dosya: ITask, recursiveQuery = false): Promise<TakipDosya> {
        return new Promise(async (resolve, reject) => {
            try {
                if (app.$store.getters.isEicraproDevMode) {
                    return resolve(await this.getMockResponse());
                }
                console.log("DosyaBul dosya", dosya);
                let dosyaEsasNo = dosya.dosya_esas_no;
                let splited = dosyaEsasNo.split('/');
                let dosyaYil = splited[0].trim();
                if (splited[1].indexOf("-") >= 0) {
                    splited[1] = splited[1].split('-')[0].trim(); //2016/7232 - ( 2015/7070 ) bunu cevirir normale
                }
                let dosyaSira = splited[1].trim();

                // UYAP sorgusu yalnizca yil+sira ile daraltilabiliyor; ayni esas no birden fazla
                // icra dairesinde bulunabildigi icin dogru dosya ASAGIDAKI eslestirme ile secilir.
                // Her pass icin AYRI talep nesnesi uretiliyor: recursive() pageNumber'i mutasyona
                // ugrattigi icin paylasilan nesne kapali pass'in ilk sayfasini atlatabilirdi.
                let acikDosya = await this.dosyalariSorgula(
                    this.talepOlustur(dosyaYil, dosyaSira, DosyaDurum.ACIK), recursiveQuery
                );
                let bulunanDosya = this.dosyaEslestir(acikDosya.items, dosya);
                if (bulunanDosya)
                    return resolve(bulunanDosya);

                let kapaliDosya = await this.dosyalariSorgula(
                    this.talepOlustur(dosyaYil, dosyaSira, DosyaDurum.KAPALI), recursiveQuery
                );
                bulunanDosya = this.dosyaEslestir(kapaliDosya.items, dosya);
                if (bulunanDosya)
                    return resolve(bulunanDosya);
                else
                    return reject(this.err);
            } catch (e) {
                console.log("eerror dosyabul", e);
                return reject(e);
            }
        })
    }

    talepOlustur(dosyaYil: string, dosyaSira: string, dosyaDurumKod: DosyaDurum): AvukatIcraDosyalariTalep {
        const talep = new AvukatIcraDosyalariTalep();
        talep.dosyaYil = parseInt(dosyaYil);
        talep.dosyaSira = parseInt(dosyaSira);
        talep.dosyaDurumKod = dosyaDurumKod;
        return talep;
    }

    async dosyalariSorgula(requestData: AvukatIcraDosyalariTalep, recursiveQuery: boolean): Promise<{ items: Array<IAvukatDosya> }> {
        if (recursiveQuery)
            return await app.$uyap.AvukatIcraDosyalari().recursive(requestData);
        return await app.$uyap.AvukatIcraDosyalari().run(requestData);
    }

    /**
     * Ad normalizasyonu ve kanonik form TEK KAYNAKTAN gelir: helper.birimAdiNormalize /
     * helper.birimAdiKanonik. GenelIslemFormWizard Excel yuklerken ayni fonksiyonlari
     * kullaniyor; kurallar ayrisirsa Excel'de kabul edilen satir burada eslesmez hale gelir.
     */
    birimAdiNormalize(birimAdi: string | undefined | null): string {
        return app.$uyapHelper.birimAdiNormalize(birimAdi);
    }

    /** Kurallar ve gerekceleri icin bkz. helper.birimAdiKanonik. */
    birimAdiKanonik(birimAdi: string | undefined | null): string {
        return app.$uyapHelper.birimAdiKanonik(birimAdi);
    }

    /** Kurallar ve gerekceleri icin bkz. helper.esasNoParcalari. */
    esasNoVaryantlari(esasNo: string | undefined | null): Array<string> {
        return app.$uyapHelper.esasNoVaryantlari(esasNo);
    }

    /**
     * UYAP'tan donen adaylar arasindan gorevin isaret ettigi dosyayi secer.
     *
     * Eslestirme sirasi (her ikisi de KESIN olcut, hicbiri bulanik degil):
     *  1. Esas no dogrulamasi (sunucu filtresine ek savunma katmani)
     *  2. birimId ile eslestirme
     *  3. birimId yoksa, icra dairesi adinin TAMAMI ile eslestirme
     *
     * NOT: task.dosya_id BILEREK olcut olarak kullanilmaz. UYAP dosyaId'leri sifreli ve
     * surekli degisiyor; bir sure sonra kullanilamaz hale geliyorlar. Zaten DosyaBul'un
     * var olma sebebi bu. Kararli kimlik ikilisi birimId + dosyaNo'dur.
     *
     * Birden fazla aday kalirsa dosya SECILMEZ ve hata firlatilir; yanlis dosyada islem
     * yapmaktansa gorevin basarisiz olmasi tercih edilir. (DEV-2643)
     */
    dosyaEslestir(data: Array<IAvukatDosya>, task: ITask): TakipDosya | null {
        if (!data || data.length === 0)
            return null;

        let adaylar = this.adaylariTekille(data.map((x: any) => TakipDosya.fromJson(x)));

        // 1. Esas no dogrulamasi
        const istenenEsasNolar = this.esasNoVaryantlari(task.dosya_esas_no);
        if (istenenEsasNolar.length > 0) {
            adaylar = adaylar.filter((aday) => {
                const adayEsasNolar = this.esasNoVaryantlari(aday.dosyaNo);
                return adayEsasNolar.some((esas) => istenenEsasNolar.indexOf(esas) >= 0);
            });
        }
        if (adaylar.length === 0)
            return null;

        // 2. birimId ile eslestirme
        const istenenBirimId = (task.birim_id ?? "").toString().trim();
        if (istenenBirimId !== "") {
            const birimIdEslesenler = adaylar.filter(
                (aday) => String(aday.birimId ?? "").trim() === istenenBirimId
            );
            if (birimIdEslesenler.length > 0)
                return this.tekAdaySec(birimIdEslesenler, task);
        }

        // 3. Icra dairesi adinin TAMAMI ile eslestirme
        const istenenBirimAdi = this.birimAdiNormalize(task.birim_adi);
        if (istenenBirimAdi === "") {
            console.warn("DosyaBul: gorevde birim_id/birim_adi yok, dosya eslestirilemiyor.", task);
            return null;
        }
        const birimAdiEslesenler = adaylar.filter(
            (aday) => this.birimAdiNormalize(aday.birimAdi) === istenenBirimAdi
        );
        if (birimAdiEslesenler.length > 0)
            return this.tekAdaySec(birimAdiEslesenler, task);

        // 4. Kanonik ad ile eslestirme. Gorevdeki ad cogu zaman IcraPro'nun kendi
        // icra_daireleri kaydindan geliyor ve UYAP yaziminin birebir aynisi olmuyor
        // ("Ankara 1. Icra Dairesi" <-> "Ankara 1. Genel Icra Dairesi").
        const istenenKanonik = this.birimAdiKanonik(task.birim_adi);
        if (istenenKanonik === "")
            return null;
        const kanonikEslesenler = adaylar.filter(
            (aday) => this.birimAdiKanonik(aday.birimAdi) === istenenKanonik
        );
        // tekAdaySec birden fazla aday kalirsa hata firlatir; tolerans yanlis dosya secmeye
        // donusmez, yalnizca TEK aday kaldiginda devreye girer.
        return this.tekAdaySec(kanonikEslesenler, task);
    }

    /**
     * Ayni dosyanin tekrar eden kayitlarini eler. UYAP cevabinda ayni dosya birden fazla kez
     * gelebiliyor; tekilleme yapilmazsa bu kayitlar "birden fazla aday" sayilip gereksiz
     * belirsizlik hatasi firlatilir. Ayni cevap icinde dosyaId sabit oldugu icin tekilleme
     * anahtari olarak kullanilabilir; yoksa birimId + dosyaNo ikilisine dusulur.
     */
    adaylariTekille(adaylar: Array<TakipDosya>): Array<TakipDosya> {
        const gorulen = new Set<string>();
        const tekil: Array<TakipDosya> = [];
        for (const aday of adaylar) {
            const dosyaId = String(aday.dosyaId ?? "").substr(0, 21);
            const anahtar = dosyaId !== ""
                ? "id:" + dosyaId
                : "ad:" + String(aday.birimId ?? "") + "|" + String(aday.dosyaNo ?? "");
            if (gorulen.has(anahtar))
                continue;
            gorulen.add(anahtar);
            tekil.push(aday);
        }
        return tekil;
    }

    /**
     * Tek bir aday kaldiysa onu dondurur. Birden fazla aday varsa hangisinin dogru oldugu
     * bilinemeyecegi icin hata firlatir.
     */
    tekAdaySec(adaylar: Array<TakipDosya>, task: ITask): TakipDosya | null {
        if (adaylar.length === 1)
            return adaylar[0];
        if (adaylar.length > 1) {
            const daireler = adaylar
                .map((aday) => aday.birimAdi + " (" + aday.birimId + ")")
                .join(", ");
            console.error("DosyaBul: birden fazla dosya eslesti", {task, daireler});
            throw {
                message: "'" + task.birim_adi + " - " + task.dosya_esas_no + "' için birden fazla dosya eşleşti " +
                    "(" + daireler + "). Yanlış dosyada işlem yapılmaması için görev durduruldu. " +
                    "Lütfen icra dairesi adını UYAP'taki yazımıyla birebir girin."
            };
        }
        return null;
    }
}
